export default __webpack_public_path__ + "static/media/send_violet.5d32cf96.svg";